import React from "react";
import { Checkbox } from "antd";
import ReversedCheckbox from "../ReversedCheckbox";
import styles from "./styles/multiSelectContent.scss";

const renderOption = option => (
  <div key={option.value} className={styles.item}>
    <ReversedCheckbox label={option.title} value={option.value} />
  </div>
);

const MultiSelectContent = ({ value, style, onChange, options, groups }) => (
  <div className={styles.itemGroup} style={style}>
    <Checkbox.Group value={value} className={styles.checkboxGroup} onChange={onChange}>
      {groups
        ? groups.map(group => (
            <div key={group.label}>
              <div className={styles.groupHeader}>{group.label}</div>
              {group.options.map(renderOption)}
            </div>
          ))
        : options.map(renderOption)}
    </Checkbox.Group>
  </div>
);

export default MultiSelectContent;



// WEBPACK FOOTER //
// ./src/components/FormControls/MultiSelectModal/MultiSelectContent.tsx